import React from 'react';
import { ArticleDetail } from '../components/articles/ArticleDetail';
import { recruitmentArticles } from '../data/articles';

export default function ArticleRecrutementPage() {
  return <ArticleDetail articles={recruitmentArticles} section="recrutement" />;
}